// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getIsPunchOutSession, getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";

const PUNCH_OUT_USER_ROLE = "PunchOut";

export const xHasPunchOutUserRole = (state: ApplicationState) => {
    const { userRoles } = getSession(state);
    return (userRoles || "").toLowerCase().includes(PUNCH_OUT_USER_ROLE.toLowerCase());
};

export const xIsPunchOutProfile = (state: ApplicationState) => {
    return getIsPunchOutSession(state) || xHasPunchOutUserRole(state);
};

export const xGetFulfillmentLabel = (state: ApplicationState) => {
    const { fulfillmentMethod, isAuthenticated, rememberMe, isGuest, shipToId, pickUpWarehouse } = getSession(state);
    const { value: shipTo } = getShipToState(state, shipToId);
    // XNG-Changes: punchout profiles do not support pickup
    const isPunchOutProfile = xIsPunchOutProfile(state);
    const isShipping = fulfillmentMethod === FulfillmentMethod.Ship || isPunchOutProfile;
    const isPickUp = fulfillmentMethod === FulfillmentMethod.PickUp && !isPunchOutProfile;
    const canShowShipTo = (isAuthenticated || rememberMe) && !isGuest && shipTo;
    if (isPickUp) {
        return {
            addressTitle: translate("Pick Up at"),
            addressLabel: pickUpWarehouse?.description ?? pickUpWarehouse?.name ?? "",
        };
    }
    return {
        addressTitle: translate("Ship To"),
        addressLabel: isShipping && canShowShipTo ? translate(shipTo.fullAddress) : "",
    };
};
